import GLightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.css';

const handleGallery = () => {
  const lightbox = GLightbox();
};

export default handleGallery;
